module.exports = __webpack_public_path__ + "media/images/black_history_month/dontaye-ball-4f385506163cd2fed0153c20ca20e6d2.svg";